import { Fragment } from 'react';

import Views from '../OrgUnitAdminUserViews';
import ViewTemplate from '../../../../components/viewTemplateOmeTeamEntry/ViewTemplate';

import OrgUnitAdminRelayEntriesTeamsWrite from './OrgUnitAdminRelayEntriesTeamsWrite';
import OrgUnitAdminRelayEntriesTeamsReadOnly from './OrgUnitAdminRelayEntriesTeamsReadOnly';

import useOrgUnitAdminRelayEntriesTeams from './UseOrgUnitAdminRelayEntriesTeams';

const OrgUnitAdminRelayEntriesTeams = () => {
  const { oUAdminEntryContextState, onBackClicked } = useOrgUnitAdminRelayEntriesTeams();

  return (
    <Fragment>
      <ViewTemplate
        viewName={Views.OME_MEET_MANAGE_RELAY_TEAMS}
        onBackButtonClicked={onBackClicked}>
        {oUAdminEntryContextState.isReadOnly === false ?
          <OrgUnitAdminRelayEntriesTeamsWrite /> :
          <OrgUnitAdminRelayEntriesTeamsReadOnly />
        }
      </ViewTemplate>
    </Fragment>
  );
};

export default OrgUnitAdminRelayEntriesTeams;